import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import { getEcolabelFilterOptions } from '../../../config/ecolabels';
import css from './SectionEcolabels.module.css';

/**
 * "Shop by ecolabel" — the ethy ecolabel artwork as a row of filter buttons.
 *
 * Each badge links into the marketplace search filtered to listings that have
 * been awarded that ecolabel. The field key and its option values are read from
 * the hosted listing-field config, so the links stay valid if the field is
 * renamed or new labels are added in Console.
 *
 * @param {Object} props
 * @param {Array<Object>} props.listingFields config.listing.listingFields
 */
const SectionEcolabels = props => {
  const { listingFields } = props;
  const { fieldKey, options } = getEcolabelFilterOptions(listingFields);

  if (options.length === 0) {
    return null;
  }

  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.heading}>
          <h2 className={css.title}>
            <FormattedMessage id="LandingPage.ecolabels.title" defaultMessage="Shop by ecolabel" />
          </h2>
          <p className={css.subtitle}>
            <FormattedMessage
              id="LandingPage.ecolabels.subtitle"
              defaultMessage="Each ecolabel stands for one specific criterion, and ethy checks the evidence before a product can carry it. Pick one to see the products that have earned it."
            />
          </p>
        </div>

        <ul className={css.grid}>
          {options.map(({ option, ecolabel, label }) => (
            <li key={ecolabel.key} className={css.item}>
              <NamedLink
                name="SearchPage"
                to={{ search: `?pub_${fieldKey}=has_any:${encodeURIComponent(option)}` }}
                className={css.card}
              >
                <img className={css.badge} src={ecolabel.src} alt="" loading="lazy" />
                <span className={css.label}>{label}</span>
              </NamedLink>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SectionEcolabels;
